import { GetOptions, MercuryPayment } from "@/core";
import { ResolveMercuryPaymentMatchPayload } from "@/core/ports/services/functions-service";
import { repositoryHost } from "@/repositories";
import { serviceHost } from "@/services";
import {
  useInfiniteQuery,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { getNextPageParam } from "../utils/page-params";

const databaseService = serviceHost.getDatabaseService();
const mercuryPaymentRepository =
  repositoryHost.getMercuryPaymentRepository(databaseService);
const functionsService = serviceHost.getFunctionsService();

export const useMercuryPayments = (options: GetOptions<MercuryPayment>) => {
  return useInfiniteQuery({
    queryKey: ["mercury-payments", "get", JSON.stringify(options)],
    queryFn: ({ pageParam }) =>
      mercuryPaymentRepository.getAll({
        ...options,
        pagination: {
          ...options.pagination,
          cursor: pageParam,
        },
      }),
    initialPageParam: "",
    getNextPageParam: getNextPageParam(options),
  });
};

export const useResolveMercuryPaymentMatch = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: ResolveMercuryPaymentMatchPayload) =>
      functionsService.resolveMercuryPaymentMatch(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["mercury-payments"] });
      // Matching also creates/removes the context-only Payment on the PO
      // (outgoing) or the sales order's invoice (incoming).
      queryClient.invalidateQueries({ queryKey: ["payments"] });
      queryClient.invalidateQueries({ queryKey: ["purchase-orders"] });
      queryClient.invalidateQueries({ queryKey: ["sales-orders"] });
      queryClient.invalidateQueries({ queryKey: ["invoices"] });
    },
  });
};
